import { Component, OnInit, ViewChild, enableProdMode } from "@angular/core";
import { CheckboxRequiredValidator, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";

import { ProcuracaoService } from "src/app/services/procuracao.service";
import Swal from "sweetalert2";
import * as FileSaver from 'file-saver';
import * as dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { DatePickerComponent, IDatePickerConfig } from "ng2-date-picker";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { MenuService } from "src/app/services/menu.service";
import { AssinaturaService } from "src/app/services/assinatura.service";

@Component({
  selector: 'app-procuracao-outorgar',
  templateUrl: 'procuracao-outorgar.component.html',
  styleUrls: ['procuracao-outorgar.component.scss']
})
export class ProcuracaoOutorgarComponent implements OnInit {

  @ViewChild('datePicker') datePicker: DatePickerComponent;

  active1: boolean = true;
  active2: boolean = false;
  active3: boolean = false;
  active4: boolean = false;
  active5: boolean = false;
  outorgadoForm: FormGroup;
  abrangenciaForm: FormGroup;
  dadosIntegracao: any;
  dadosFormatados: any;
  dadosContribuinte: any;
  contribuinteFormatado: any;
  passo: number = 1;
  representanteLegal: string;
  cpfRepresentanteLegal: string;
  outorgante: string;
  cpfCnpjOutorgante: string;
  codigoOutorgado: number;
  ieOutorgante: string;
  ged: any;
  tipoProcuracao: any;
  tipoDocumento: any;
  dataInicio: any = new Date();
  dataFim: any;
  dataFimCalendario: any;
  dataAtual: any = new Date();
  datasFiltro = {
    dataInicio: null,
    dataFim: null
  }
  arquivos: any = [];
  readonly: boolean = false;
  arquivoConvertido: any;
  base64: any;
  base64Assinado: any;
  // base64: any = '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';
  src: any;
  idProcuracao: number;
  indexTipoProcuracao: number;
  loading: boolean = false;
  downloadArquivo: boolean = false;
  envioAssinatura: boolean = false;
  arquivoAssinatura: any;
  procuradorExiste = false;
  calendario: boolean = false;
  datePickerConfig: IDatePickerConfig = {
    disableKeypress: true,
    drops: "down",
    format: 'DD/MM/YYYY'
  }
  listaPoderes: any;
  poderesSelecionados: Array<any> = [];
  mascaraAtual: any = null;
  mascarasPorDocumento = {
    7: '00000000000', // CNH
    9: 'AA000000', // Passaporte
    10: 'AA-000000', // O.A.B.
    11: '000000/A-0', // C.R.C.
    12: '000.000.000-00', // CPF
    13: '00.000.000/0000-00', // CNPJ
    60: '0000000-0000', // CTPS 
    61: '000.000.000-000', // Certificado de Reservista
    62: '000.000.000.000-0', // Cédula de Identidade de Estrangeiro
    63: '00000000000', // Carteira de Identidade Profissional
    74: '000.000.000.000-0', // CRNM
    75: '000.000.000.000-0', // RNE
    76: '000000', // CRM
    77: '00000000000', // CREA
  };
  rgMaxlength: number = null; 
  customPatterns = { 
    'A': { pattern: new RegExp('[a-zA-Z\u00C0-\u00FF -]') }
  };
  cpfUsuarioLogado: string;


  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private procuracaoService: ProcuracaoService,
    private menuService: MenuService,
    private datePipe: DatePipe,
    private assinaturaService: AssinaturaService
  ) {
    dayjs.locale('pt-br');
    enableProdMode();
  }

  ngOnInit(): void {

    this.carregarStorage();
    setTimeout(() => {
      this.dadosIntegracao = localStorage.getItem('dadosIntegracao');
      this.dadosFormatados = JSON.parse(this.dadosIntegracao);
      this.dadosContribuinte = localStorage.getItem('contribuinteEmUso');
      this.contribuinteFormatado = JSON.parse(this.dadosContribuinte);
      this.representanteLegal = this.dadosFormatados.sessao.cadastro.dscNomeCadastro;
      this.cpfRepresentanteLegal = this.dadosFormatados.sessao.cadastro.cpfCnpj;
      this.outorgante = this.contribuinteFormatado.dscRazaoSocial;
      this.cpfCnpjOutorgante = this.contribuinteFormatado.cadastro.cpfCnpj;
      this.ieOutorgante = this.contribuinteFormatado.dscIe;
    }, 500);
    this.getGed();
    this.getTipoProcuracao();
    this.getPoderes();
    this.dataInicio = this.datePipe.transform(this.dataInicio, 'dd/MM/yyyy');
    this.criarFormulario();
    this.setObservableAssinatura();
    this.dataAtual.setDate(this.dataAtual.getDate());
  }

  setObservableAssinatura() {
    let code;
    this.assinaturaService.assinatura$.subscribe(
      res => {
        if (res != '') {
          code = res;
          this.enviarCodeCallbackAssinatura(code);
        }
      },
      err => {
        Swal.fire({
          icon: 'error',
          text: 'Ocorreu um erro ao assinar o comunicado'
        })
      }
    )
  }

  enviarCodeCallbackAssinatura(code) {
    let token: string;
    let arquivo: File;
    this.assinaturaService.enviarCodigoCallback(code).subscribe(
      res => {
        token = res['access_token'];
        Swal.fire({
          icon: 'success',
          text: `token: ${res['access_token']}`
        })
      },
      err => {
        Swal.fire({
          icon: 'error',
          text: 'Ops! Ocorreu uma falha de comunicação. Tente novamente mais tarde.'
        })
      },
      () => {
        arquivo = this.assinaturaService.converterBase64ParaFile(this.base64);
        this.receberArquivoAssinado(token, arquivo);
      }
    )
  }

  receberArquivoAssinado(token, arquivo) {
    this.assinaturaService.getArquivoAssinado(token, arquivo).subscribe(
      res => {
        this.base64Assinado = res['pdfArquivoBase64'];
      },
      err => {
        Swal.fire({
          icon: 'error',
          text: 'Ops! Ocorreu uma falha de comunicação. Tente novamente mais tarde.'
        })
      },
      () => {
        this.src = this.converterParaArrayBuffer(this.base64Assinado);
      }
    )
  }


  carregarStorage() {
    const dados = localStorage.getItem('dadosIntegracao');
    if (dados) {
      this.dadosFormatados = JSON.parse(dados);
      this.cpfUsuarioLogado = this.dadosFormatados.sessao.cadastro.cpfCnpj;
    }
    console.log('dados', this.cpfUsuarioLogado);
  }

  criarFormulario() {
    this.outorgadoForm = this.formBuilder.group({
      tipoPessoa: ['', Validators.required],
      cpfCnpj: ['', Validators.required],
      nomeProcurador: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(200)])],
      email: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.email])],
      tipoDocumento: ['', Validators.required],
      documento: ['', Validators.required],
      nomeMae: [''],
    });

    this.abrangenciaForm = this.formBuilder.group({
      tipoProcuracao: [{ value: 5, disabled: true }, Validators.required],
      dataInicio: [this.dataInicio, Validators.required],
      dataFim: ['', Validators.required],
      dataFimCalendario: ['']
    })
  }

  proximoPasso() {
    if (this.passo == 1) {
      this.active1 = false;
      this.active2 = true;
      this.passo++;
    } else if (this.passo == 2) {
      this.active2 = false;
      this.active3 = true;
      this.passo++;
    } else if (this.passo == 3) {
      this.active3 = false;
      this.active4 = true;
      this.passo++;
    } else if (this.passo == 4) {
      this.loading = true;
      //this.abrirAutenticadorAssinatura();
      let dataAtual = new Date();
      let obj: any = {};
      obj.procuracaoDTO = {};
      obj.procuracaoDTO.codCadastro = this.dadosFormatados.sessao.cadastro.codigo;
      obj.procuracaoDTO.codContribuinte = this.contribuinteFormatado.codigo;
      obj.procuracaoDTO.cadastroOutorgado = {};
      this.procuradorExiste == true
        ? obj.procuracaoDTO.cadastroOutorgado.codCadastro = this.codigoOutorgado
        : null;
      obj.procuracaoDTO.cadastroOutorgado.cpfCnpj = this.outorgadoForm.controls.cpfCnpj.value;
      obj.procuracaoDTO.cadastroOutorgado.razaoSocial = this.outorgadoForm.controls.nomeProcurador.value;
      obj.procuracaoDTO.cadastroOutorgado.emailUsuario = this.outorgadoForm.controls.email.value;
      this.outorgadoForm.controls.nomeMae.value
        ? obj.procuracaoDTO.cadastroOutorgado.dscNomeMae = this.outorgadoForm.controls.nomeMae.value
        : null;
      obj.procuracaoDTO.dataInicio = this.datePipe.transform(dataAtual, 'yyyy-MM-dd');
      obj.procuracaoDTO.dataFim = this.datePipe.transform(this.dataFim, 'yyyy-MM-dd');
      obj.procuracaoDTO.dscDocumento = this.getDescricaoDocumento(this.outorgadoForm.controls.tipoDocumento.value);
      obj.procuracaoDTO.codTipoProcuracao = this.abrangenciaForm.controls.tipoProcuracao.value;
      obj.procuracaoDTO.poderes = [];
      this.poderesSelecionados.map(item => obj.procuracaoDTO.poderes.push({ dscMenu: item.dscMenu, id: item.codigo }));
      if (this.arquivos.length > 0) {
        obj.gedsDTO = [{}];
        obj.gedsDTO[0].idUsuario = this.dadosFormatados.sessao.cadastro.codigo;
        obj.gedsDTO[0].idContribuinte = this.contribuinteFormatado.codigo;
        obj.gedsDTO[0].numeroDocumento = this.outorgadoForm.controls.documento.value;
        obj.gedsDTO[0].nomeArquivo = this.arquivos[0].name;
        obj.gedsDTO[0].arquivo = this.arquivoConvertido;
      }
      this.procuracaoService.enviarProcuracao(obj).subscribe(
        res => {
          this.base64 = res['procuracaoPdf'].arquivo;
          this.src = this.converterParaArrayBuffer(this.base64);
          this.idProcuracao = res['id'];
        },
        err => {
          if (err.error.msg == 'O arquivo deve estar em formato PDF!') {
            Swal.fire({
              icon: 'error',
              text: err.error.msg
            })
            this.active4 = false;
            this.active2 = true;
            this.passo = 2;
          } else {
            Swal.fire({
              icon: 'error',
              text: 'Ops! Ocorreu uma falha de comunicação. Tente novamente mais tarde.'
            });
            this.router.navigate(['procuracao']);
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.active4 = false;
          this.active5 = true;
          this.passo++;
        }
      )
    }
  }

  voltarPasso() {
    if (this.passo == 2) {
      this.active2 = false;
      this.active1 = true;
      this.passo--;
    } else if (this.passo == 3) {
      this.active3 = false;
      this.active2 = true;
      this.passo--;
    } else if (this.passo == 4) {
      this.active4 = false;
      this.active3 = true;
      this.passo--;
    } else if (this.passo == 5) {
      this.active5 = false;
      this.active4 = true;
      this.passo--;
    }
  }

  abrirAutenticadorAssinatura() {
    const url = 'https://cas.iti.br/oauth2.0/authorize?response_type=code&client_id=contibuintesefaztoprod&redirect_uri=https://dec.sefaz.to.gov.br&scope=sign';
    window.open(url, 'authPopup', 'width=600, height=600');
  }

  getDataInicio(event) {
    if (this.dataInicio && this.dataInicio < this.dataAtual) {
      setTimeout(() => {
        this.datasFiltro.dataInicio = null;
        this.dataInicio = null;
        Swal.fire({
          icon: 'warning',
          text: 'Data inferior a data do dia de hoje'
        })
      }, 150);

    }
    if (this.dataInicio && this.dataFim && this.dataInicio > this.dataFim) {
      setTimeout(() => {
        this.datasFiltro.dataFim = null;
        this.dataFim = null;
      }, 150);
    }
  }

  getDataFim(event) {
    if (this.dataFim && this.dataFim <= this.dataAtual) {
      setTimeout(() => {
        this.dataFimCalendario = null;
        this.dataFim = null;
        Swal.fire({
          icon: 'warning',
          text: 'Data inferior ou igual ao de início de outorga. Deve ser no mínimo 1 dia a mais que a data de início da outorga'
        })
      }, 150);
    }
  }

  getPoderes() {
    this.menuService.getMenusAutorizados(2).subscribe(
      res => {
        this.listaPoderes = res;
        this.listaPoderes = this.listaPoderes.filter(item => item.codigo != 10004 && item.codigo != 10003 && item.codigo != 30003 && item.codigo != 30001); 
        this.listaPoderes = this.listaPoderes.map(item => ({...item, selected: false}));
      }
    )
  }

  checkboxToggle(item) {
    item.selected = !item.selected;
    this.poderesSelecionados = this.getPoderesSelecionados();

  }

  getPoderesSelecionados() {
    return this.listaPoderes.filter(item => item.selected);
  }

  desistir() {
    Swal.fire({
      icon: 'question',
      text: 'Deseja desistir e voltar para a página anterior?',
      confirmButtonText: 'Sim',
      showCancelButton: true,
      cancelButtonText: 'Não'
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['procuracao'])
      } else if (result.isDenied) {
        Swal.close();
      }
    })
  }

  getGed() {
    this.procuracaoService.getGed().subscribe(
      res => {
        this.ged = res;
      }
    )
  }

  getTipoProcuracao() {
    this.procuracaoService.getTipoProcuracao().subscribe(
      res => {
        this.tipoProcuracao = res;
        const index = this.tipoProcuracao.findIndex(item => item.codTipoProcuracao === 5);
        this.indexTipoProcuracao = index;
        this.abrangenciaForm.controls.tipoProcuracao.setValue(5);
      }
    );
  }
  

  validarCpfCnpj() {
    const control = this.outorgadoForm.controls.cpfCnpj;
    const cpfDigitado = (control.value || '').toString().replace(/\D/g, '');

    if (cpfDigitado === this.cpfUsuarioLogado) {
      Swal.fire({
        icon: 'warning',
        text: 'Prezado(a), não é possível ser outorgante e outorgado da mesma procuração eletrônica. Por favor, insira outro CPF/CNPJ de outro usuário para essa função.'
      });
      control.reset();
      return;
    }

    if (this.outorgadoForm.controls.tipoPessoa.value == 0 && this.outorgadoForm.controls.cpfCnpj.touched) {
      this.outorgadoForm.controls.cpfCnpj.setValidators(Validators.compose([Validators.minLength(11), Validators.maxLength(11)]));
      this.outorgadoForm.controls.cpfCnpj.updateValueAndValidity();
    } else {
      this.outorgadoForm.controls.cpfCnpj.setValidators(Validators.compose([Validators.minLength(14)]));
      this.outorgadoForm.controls.cpfCnpj.updateValueAndValidity();
    }
  }

  verificarAdesaoUsuario() {
    if (this.outorgadoForm.controls.cpfCnpj.errors) {
      return;
    }

    let cpfCnpj = this.outorgadoForm.controls.cpfCnpj.value;
    this.procuracaoService.verificarAdesaoUsuario(cpfCnpj).subscribe((res: any) => {
      this.outorgadoForm.controls.nomeProcurador.setValue(res.dscNomeCadastro);
      this.outorgadoForm.controls.email.setValue(
         res.emails && res.emails.length > 0 ? res.emails[0].descricao : ''
      );
      this.outorgadoForm.controls.nomeProcurador.disable();
      this.outorgadoForm.controls.email.disable();
      this.outorgadoForm.controls.cpfCnpj.disable();
      this.readonly = true;
      this.procuradorExiste = true;
      this.codigoOutorgado = res.codigo;

    }, error => {
      if(error.error.status == 400) {
        let msg = error.error.mensagem;
        if (cpfCnpj.length == 11) {
          msg = msg.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
        } else {
          msg = msg.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
        }
        
        Swal.fire({
          icon: 'info',
          text: msg
        });
        this.outorgadoForm.controls.cpfCnpj.reset();
      }
    });
  }

  onTipoPessoaClick(tipo: string) {
    this.outorgadoForm.controls.cpfCnpj.reset();
    this.outorgadoForm.controls.nomeProcurador.reset();
    this.outorgadoForm.controls.email.reset();
  
    this.outorgadoForm.controls.cpfCnpj.enable();
    this.outorgadoForm.controls.nomeProcurador.enable();
    this.outorgadoForm.controls.email.enable();
    
    this.readonly = false;
    this.procuradorExiste = false;
  
    if (tipo === 'fisica') {
      this.outorgadoForm.controls.cpfCnpj.setValidators([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11)
      ]);
    } else if (tipo === 'juridica') {
      this.outorgadoForm.controls.cpfCnpj.setValidators([
        Validators.required,
        Validators.minLength(14)
      ]);
    }
    this.outorgadoForm.controls.cpfCnpj.updateValueAndValidity();
  }

  validarDigitoCpfCnpj() {
    if (this.outorgadoForm.controls.tipoPessoa.value == 0 && cpf.isValid(this.outorgadoForm.controls.cpfCnpj.value) == false) {
      this.outorgadoForm.controls.cpfCnpj.setErrors({ 'invalid': true });
    } else if (this.outorgadoForm.controls.tipoPessoa.value == 1 && cnpj.isValid(this.outorgadoForm.controls.cpfCnpj.value) == false) {
      this.outorgadoForm.controls.cpfCnpj.setErrors({ 'invalid': true });
    } else {
      this.outorgadoForm.controls.cpfCnpj.setErrors(null);
    }

  }

  anexo(event) {
    this.arquivos[0] = event.target.files[0];
    this.converterParaBase64(this.arquivos[0]);
  }

  deletarArquivo(index) {
    this.arquivos.splice(index, 1);
  }

  converterParaBase64(arquivo) {
    const file = arquivo;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.arquivoConvertido = (<string>reader.result).split(',')[1];
    }
  }

  converterParaArrayBuffer(base64) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;

  }

  mostrarCalendario() {
    this.calendario = true;
  }

  toggleModal() {
    if (this.downloadArquivo == true) {
      this.downloadArquivo = false;
    } else {
      this.downloadArquivo = true;
    }
  }

  confirmarAssinaturaPosterior() {
    Swal.fire({
      icon: 'question',
      text: 'A não assinatura do documento, não formalizará a outorga da procuração',
      confirmButtonText: 'OK',
      showCancelButton: true,
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['procuracao']);
      } else {
        Swal.close();
      }
    })
  }

  baixarArquivo() {
    var blob = new Blob([this.src], { type: 'application/pdf' });
    FileSaver.saveAs(blob, 'procuracao');
    window.open('https://www.gov.br/governodigital/pt-br/assinatura-eletronica', '_blank');
    this.downloadArquivo = false;
    this.envioAssinatura = true;
  }

  arquivoAssinado(event) {
    this.arquivoAssinatura = event.target.files[0];
  }

  getTipoProcuracaoIndex() {
    for (let i = 0; i < this.tipoProcuracao.length; i++) {
      if (this.abrangenciaForm.controls.tipoProcuracao.value == this.tipoProcuracao[i].codTipoProcuracao) {
        this.indexTipoProcuracao = i;
        break;
      }
    }
  }

  confirmarOutorga() {
    this.loading = true;
    let arquivoConvertido;
    let obj: any = {};
    const file = this.arquivoAssinatura;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      arquivoConvertido = (<string>reader.result).split(',')[1];
      obj.arquivo = arquivoConvertido;
      this.procuracaoService.confirmarOutorga(obj, this.idProcuracao).subscribe(
        res => {
          Swal.fire({
            icon: 'success',
            text: 'Outorga Formalizada'
          })
        },
        err => {
          Swal.fire({
            icon: 'error',
            text: 'Ops! Ocorreu uma falha de comunicação. Tente novamente mais tarde.'
          });
          this.router.navigate(['procuracao']);
        },
        () => {
          this.loading = false;
          this.router.navigate(['procuracao']);
        }
      )
    }


  }

  desistirOutorga() {
    Swal.fire({
      icon: 'question',
      text: 'Você tem certeza que deseja desistir dessa outorga? Todos os dados serão descartados.',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['procuracao'])
      } else if (result.isDenied) {
        Swal.close();
      }
    });
  }

  tipoDocumentoSelecionado(event: any) {
    const codigoSelecionado = Number(event.target.value);
    this.mascaraAtual = this.mascarasPorDocumento[codigoSelecionado] || '';
    if (codigoSelecionado === 8 || codigoSelecionado === 1 || codigoSelecionado === 79) {
      this.rgMaxlength = 15;
    } else {
      this.rgMaxlength = null;
    }
  
    this.outorgadoForm.controls['documento'].reset();
  }

  getDescricaoDocumento(codigo: number): string {
    if (!this.ged || !codigo) {
      return '';
    }
    const documento = this.ged.find(item => item.codigo === Number(codigo));
    return documento ? documento.descricaoGed : '';
  }

}